import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBreadcrumbs,{attrs:{"divider":">","items":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }